export const hasNavigatorPermissions = (): boolean => {
  if (typeof navigator === "undefined" || !navigator.permissions) {
    return false;
  }
  return true;
};

export const getNavigatorPermissions = () => {
  if (typeof navigator === "undefined" || !navigator.permissions) {
    return null;
  }
  return navigator.permissions;
};

